'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feiseanna = require('../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _landingPage = require('./landing-page');

var _landingPage2 = _interopRequireDefault(_landingPage);

var _register = require('./register');

var _register2 = _interopRequireDefault(_register);

var _registrationHistory = require('./registration-history');

var _registrationHistory2 = _interopRequireDefault(_registrationHistory);

var _results = require('./results');

var _results2 = _interopRequireDefault(_results);

require('./school-results-for-teachers');

var _registrationsForSchool = require('./registrations-for-school');

var _registrationsForSchool2 = _interopRequireDefault(_registrationsForSchool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//ng modules


var FeisController = function FeisController() {
  _classCallCheck(this, FeisController);
};

exports.default = angular.module('ifeis.routes.feiseanna.one', ['ui.router', 'ngMaterial', 'ifeis.feiseanna', 'ifeis.routes.feiseanna.one.admin', 'ifeis.routes.feiseanna.one.landing-page', 'ifeis.routes.feiseanna.one.register', 'ifeis.routes.feiseanna.one.registration-history', 'ifeis.routes.feiseanna.one.results', 'ifeis.routes.feiseanna.one.results-for-teacher', 'ifeis.routes.feiseanna.one.registrations-for-school']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one', {
    abstract: true,
    controller: 'FeisController',
    resolve: {
      feis: function feis(fFeisService, $stateParams) {
        return fFeisService.one($stateParams.id);
      },
      metadata: function metadata(fFeisService, $stateParams) {
        return fFeisService.all().then(function (feiseanna) {
          return feiseanna.filter(function (f) {
            return f.feis.id === $stateParams.id;
          }).pop() || { grants: [] };
        }, function () {
          return { grants: [] };
        });
      },
      isGod: function isGod(fSession) {
        return fSession.isGod();
      },
      account: function account(fSession) {
        return fSession.user().catch(function () {
          return null;
        });
      }
    },
    template: require('./tpl.html'),
    url: '/:id/:slug'
  });
}).controller('FeisController', FeisController).run(function ($state, $rootScope, editableThemes, editableOptions, fFeisService) {
  $rootScope.$on('$stateChangeStart', function (ev, to, toParams, from, fromParams) {
    if (toParams.id) {
      fFeisService.one(toParams.id).then(function (feis) {
        // Save on root scope for breadcrumbs on all screens
        $rootScope.feis = feis;
        $rootScope.breadcrumbsFeisName = feis.name;
      });
    }
  });

  $rootScope.$on('$stateChangeError', function (event, toState, toParams) {
    if (toState.name == 'feiseanna.one.admin.stages' || toState.name == 'feiseanna.one.admin.tabulations' || toState.name == 'feiseanna.one.manager') {
      fFeisService.one(toParams.id).then(function (feis) {
        $state.go('feiseanna.one.admin.manager', feis);
      }).catch(function () {
        $state.go('not-found', {}, { location: false });
      });
    } else if (toState.name.indexOf('feiseanna.one.landing-page') === 0) {
      $state.go('not-found', {}, { location: false });
    }
  });

  var materialTheme = angular.copy(editableThemes.default);
  materialTheme.controlsTpl = '<md-input-container class="md-default-theme md-input-has-value"></md-input-container>';
  materialTheme.errorTpl = '<div class="editable-error" ng-show="$error" ng-bind="$error"></div>';
  materialTheme.buttonsTpl = '<span class="ng-hide"></span>';

  editableThemes.material = materialTheme;
  editableOptions.theme = 'material';
  editableOptions.blurElem = 'submit';
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/index.js
// module id = 93
// module chunks = 0